export const URLS = [
    {
        GetUsers: 'https://achiapp.pythonanywhere.com/fi/getusers',
        All_Items: 'https://achiapp.pythonanywhere.com/fi/allItems',
        All_Customers: 'https://achiapp.pythonanywhere.com/fi/customers/',
        Category_list: 'https://achiapp.pythonanywhere.com/fi/category_list',
        ids: 'https://achiapp.pythonanywhere.com/fi/get_product_ids',
        oneItem: 'https://achiapp.pythonanywhere.com/fi/get_product_by_id',
        invoices: 'https://achiapp.pythonanywhere.com/fi/get_invoice_list',
        invoice_items:
            'https://achiapp.pythonanywhere.com/fi/collected_products',
    },
];
